import React from 'react';

import { Box, Card, CardContent, Grid, Link, Typography } from '@mui/material';
import OpenInNewRoundedIcon from '@mui/icons-material/OpenInNewRounded';

import { COLOR_GREY_800, COLOR_PRIMARY_1 } from 'src/utils/colors';
import { COLOR_TOOLTIP_BACKGROUND } from 'src/utils/const';

const MainKPITooltip = ({ tooltipConfig, matches }) => {
  return (
    <Grid container spacing={1} direction="column">
      {/* Definition */}
      <Grid item>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          {tooltipConfig.description.length > 0 &&
            tooltipConfig.description.map((line, index) => (
              <Typography key={index} variant="body2" sx={{ fontWeight: 500 }}>
                {line}
              </Typography>
            ))}
        </Box>
      </Grid>

      {/* Helping URLs */}
      {tooltipConfig.helpingUrls && (
        <Grid item>
          {tooltipConfig.helpingUrls.map((url, index) => (
            <Typography variant="body2" sx={{ fontWeight: 500 }} key={index}>
              {url.text}
              <Link href={url.ctaURL} target="_blank" rel="noreferrer" sx={{ fontWeight: 'bold' }}>
                {url.ctaText}
              </Link>
            </Typography>
          ))}
        </Grid>
      )}

      {/* Calculation Section */}
      {tooltipConfig.calculation && (
        <Grid item>
          <Typography
            variant="subtitle2"
            gutterBottom
            sx={{ fontWeight: 'bold', borderBottom: `1px solid ${COLOR_GREY_800}`, pb: 0.5 }}
          >
            Calculation:
          </Typography>
          <Typography variant="body2" sx={{ fontWeight: 500 }}>
            {tooltipConfig.calculation.length > 0 &&
              tooltipConfig.calculation.map((line, index) =>
                tooltipConfig.calculation.length > 1 ? (
                  <Box key={index} component="li">
                    {line}
                  </Box>
                ) : (
                  <Box key={index}>{line}</Box>
                )
              )}
          </Typography>
        </Grid>
      )}

      {/* Calculation Reference */}

      <Grid item>
        {tooltipConfig.calcRef &&
          tooltipConfig.calcRef.length > 0 &&
          tooltipConfig.calcRef.map((line, index) => (
            <Box sx={{ borderLeft: `2px solid ${COLOR_GREY_800}`, pl: 1 }} component="li">
              <Typography variant="caption" sx={{ fontWeight: 500 }}>
                {line}
              </Typography>
            </Box>
          ))}
      </Grid>

      {/* CTA URL */}
      {tooltipConfig.ctaUrl && (
        <Grid item sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
          <Typography variant="body2" sx={{ fontWeight: 500 }}>
            {tooltipConfig.urlTexts?.text}
            <Link
              href={tooltipConfig.ctaUrl}
              target="_blank"
              rel="noreferrer"
              sx={{ fontWeight: 'bold', display: 'inline-flex', alignItems: 'center', gap: 0.5 }}
            >
              {tooltipConfig.urlTexts?.ctaText || 'Learn More'}
              {tooltipConfig.urlTexts?.showLinkIcon && (
                <OpenInNewRoundedIcon sx={{ fontSize: 14 }} />
              )}
            </Link>
          </Typography>
        </Grid>
      )}
    </Grid>
  );
};

export default MainKPITooltip;
